// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3aOiP","Success":"Button_Success__BFMHs","Danger":"Button_Danger__1_zXF"};